interface HeroProps {
  onRegister: () => void;
}

export default function Hero({ onRegister }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/c7d13b7077e844addab1a39633e45dd1.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 text-center">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight px-2">
            Liên Minh Du Lịch Mỹ 2026
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-white mb-3 sm:mb-4 px-2">
            Chúng Tôi Tìm Đại Lý & Đối Tác Chiến Lược
          </h2>
        </div>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-2 sm:mb-3 md:mb-4 max-w-4xl mx-auto font-light px-4">
          Hệ sinh thái sản phẩm độc quyền • Chính sách vượt trội • Hợp tác bền vững
        </p>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-8 sm:mb-10 md:mb-12 max-w-4xl mx-auto font-light px-4">
          Khách hàng & Đối tác làm trung tâm WinWinWin
        </p>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
          <button 
            onClick={onRegister}
            className="w-full sm:w-auto px-6 sm:px-8 md:px-10 py-4 sm:py-5 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-base sm:text-lg font-semibold rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-2xl hover:shadow-blue-500/50 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Đăng Ký Trở Thành Đại Lý
          </button>
          
          <a 
            href="#qr-section" 
            className="w-full sm:w-auto px-6 sm:px-8 md:px-10 py-4 sm:py-5 bg-white/10 backdrop-blur-md text-white text-base sm:text-lg font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer text-center"
          >
            Quét Mã QR Tham Gia Zalo
          </a>
        </div>
      </div>

      <div className="absolute bottom-6 sm:bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <i className="ri-arrow-down-line text-white text-3xl sm:text-4xl"></i>
      </div>
    </section>
  );
}